/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `GET /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdGetRequest {
  id: string;
}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `GET /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdGetResponse {
  /**
   * 属性组id
   */
  id?: number;
  /**
   * 属性组名称
   */
  name?: string;
  /**
   * 设备场景id
   */
  sceneId?: number;
  /**
   * 设备场景名称
   */
  sceneName?: string;
  /**
   * 属性列表
   */
  dataPropertyList?: {
    /**
     * 属性id
     */
    id?: number;
    /**
     * 属性名称
     */
    name?: string;
  }[];
}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `GET /api/data-property-group/{id}`
 */
type ApiDataPropertyGroupIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-property-group/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `GET /api/data-property-group/{id}`
 */
const apiDataPropertyGroupIdGetRequestConfig: ApiDataPropertyGroupIdGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-property-group/{id}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataPropertyGroupIdGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `GET /api/data-property-group/{id}`
 */
export const apiDataPropertyGroupIdGet = /*#__PURE__*/ (
  requestData: DataPropertyGroupIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DataPropertyGroupIdGetResponse>(prepare(apiDataPropertyGroupIdGetRequestConfig, requestData), ...args);
};

apiDataPropertyGroupIdGet.requestConfig = apiDataPropertyGroupIdGetRequestConfig;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `DELETE /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdDeleteRequest {
  /**
   * id
   */
  id: string;
}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `DELETE /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdDeleteResponse {}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `DELETE /api/data-property-group/{id}`
 */
type ApiDataPropertyGroupIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-property-group/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `DELETE /api/data-property-group/{id}`
 */
const apiDataPropertyGroupIdDeleteRequestConfig: ApiDataPropertyGroupIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-property-group/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataPropertyGroupIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `DELETE /api/data-property-group/{id}`
 */
export const apiDataPropertyGroupIdDelete = /*#__PURE__*/ (
  requestData: DataPropertyGroupIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DataPropertyGroupIdDeleteResponse>(
    prepare(apiDataPropertyGroupIdDeleteRequestConfig, requestData),
    ...args
  );
};

apiDataPropertyGroupIdDelete.requestConfig = apiDataPropertyGroupIdDeleteRequestConfig;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `PUT /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdPutRequest {
  /**
   * 场景id
   */
  sceneId: number;
  /**
   * 属性组名称
   */
  name: string;
  /**
   * 数据属性列表
   */
  dataPropertyIds: number[];
  id: string;
}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `PUT /api/data-property-group/{id}`
 */
export interface DataPropertyGroupIdPutResponse {}

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `PUT /api/data-property-group/{id}`
 */
type ApiDataPropertyGroupIdPutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-property-group/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `PUT /api/data-property-group/{id}`
 */
const apiDataPropertyGroupIdPutRequestConfig: ApiDataPropertyGroupIdPutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-property-group/{id}',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataPropertyGroupIdPut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock属性组↗](http://10.50.16.213:40001/project/283/interface/api/cat_2003)
 * @请求头 `PUT /api/data-property-group/{id}`
 */
export const apiDataPropertyGroupIdPut = /*#__PURE__*/ (
  requestData: DataPropertyGroupIdPutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<DataPropertyGroupIdPutResponse>(prepare(apiDataPropertyGroupIdPutRequestConfig, requestData), ...args);
};

apiDataPropertyGroupIdPut.requestConfig = apiDataPropertyGroupIdPutRequestConfig;

/* prettier-ignore-end */
